module.exports = __webpack_public_path__ + "img/Embers-Adrift-Brand-White-Colour.ca16f100.png";